  export default {
    props: {
      peizhi:'',
    }
    ,
    data() {
      return {
        options: [],
        value: '',
        tableData: [],
        tableData1: [],
        search: '',
        input:'',
        checked:'',
        activeName:'',
        currentPage:0,
        currentPage2:0,
        total:0,
        length:15,
        offset:0,
        total2:0,
        length2:15,
        offset2:0,
        username1:'',
        username2:'',
        phone1:'',
        phone2:'',

      }
    },
    methods: {
      // 分页函数
      handleCurrentChange(val) {
        this.offset = (val-1)*this.length
        this.gethttp1()
      },
      handleSizeChange(val) {
        this.offset = 0
        this.length = val
        this.gethttp1()
      },
      //分页end
      // 分页函数
      handleCurrentChange2(val) {
        this.offset2 = (val-1)*this.length2
        this.gethttp2()
      },
      handleSizeChange2(val) {
        this.offset2 = 0
        this.length2 = val
        this.gethttp2()
      },
      //分页end
      // 获取已添加学生列表信息
      gethttp1(){
            this.$post('class_users/search', {
                      offset:this.offset,  
                      length:this.length,
                      user_name:this.username1,
                      user_phone:this.phone1,
                      class_id:this.peizhi.id,
                      token: this.$store.state.authority_management,
            }).then(res => {
              this.tableData = res.data.result.data
              this.total = res.data.result.total         
            })
      },
      // 获取未已添加学生列表信息
      gethttp2(){
            this.$post('users/search_pay_project', {
                      offset:this.offset2,  
                      length:this.length2,
                      user_name:this.username2,
                      user_phone:this.phone2,
                      product_id: this.peizhi.product_id,
                      // class_id:this.peizhi.id,
                      token: this.$store.state.authority_management,
            }).then(res => {
              // console.log(res.data)
              this.tableData1 = res.data.result.data
              this.total2 = res.data.result.total         
            })
      },
      //全部删除
      DeleteList(index,row){
        this.$post('class_users/delete',{
            class_id: this.peizhi.id,
            token: this.$store.state.authority_management,
        })
        .then(res=>{
          if(res.data.status=='success'){
            this.gethttp1()
            this.gethttp2()
            this.success('删除成功！')
          }else{
            this.tishi('删除失败！')
          }
        })
      },
      //删除
      Delete(index,row){
        this.$post('class_users/delete',{
            class_id: this.peizhi.id,
            user_id: row.id,
            token: this.$store.state.authority_management,
        })
        .then(res=>{
          if(res.data.status=='success'){
            this.gethttp1()
            this.gethttp2()
            this.success('删除成功！')
          }else{
            this.tishi('删除失败！')
          }
        })
      },
      //添加全部学生
      addUserList(index,row){
        this.$post('class_users/create_all',{
                class_id: this.peizhi.id,
                token: this.$store.state.authority_management,
                product_id: this.peizhi.product_id
                
        })
        .then(res => {
          // console.log(res)
          if(res.data.status=='success'){
            this.gethttp1()
            this.gethttp2()
            this.success('添加成功！')
          }else{
            this.tishi('添加失败！')
          }
        })
      },
    //添加学生
      addUser(index,row){
        this.$post('class_users/create',{
               class_id: this.peizhi.id,
               user_id: row.user_id,
               token: this.$store.state.authority_management,
               purchased_id: row.purchased_id
        })
        .then(res => {
                    // console.log(res)
          if(res.data.status=='success'){
            this.gethttp1()
            this.gethttp2()
            this.success('添加成功！')
          }else{
            this.tishi('添加失败！')
          }
        })
      },
      // 提示消息
      tishi(text) {
        this.$message.error(text);
      },
      // 成功消息
      success(text) {
        this.$message({
          message: text,
          type: 'success'
        });
      },

      //切换标签页
      handleClick(tab, event) {
        // console.log(tab, event);
      },

      //删除提示框
      yonghujiaoyuan(index,row) {
        this.$confirm('此操作将删除所有学员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.DeleteList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
    },


    created(){
      this.gethttp1()
      this.gethttp2()
    },
  }